$(document).ready(function () {
    $('.redirectmodal-container, #closebtn *').click(function () {
        blurScreen(0);
        $('.redirectmodal-container').css("display", "none");
        $('#redirectmodal').css({
            "display": "none",
            "opacity": "0"
        });
        $('body').css({
            "overflow": "visible"
        });
    });

    $('.redirectmodal-container *').click(function (e) {
        e.stopPropagation();
    });
});
$(document).ready(function () {
    $('.redirectmodal-container, #continuenoemail *').click(function () {
        blurScreen(0);
        $('.redirectmodal-container').css("display", "none");
        $('#redirectmodal').css({
            "display": "none",
            "opacity": "0"
        });
        $('body').css({
            "overflow": "visible"
        });
    });

    $('.redirectmodal-container *').click(function (e) {
        e.stopPropagation();
    });
});
$(document).ready(function () {
    $('.redirectmodal-container, #redirbtn *').click(function () {
        blurScreen(0);
        $('.redirectmodal-container').css("display", "none");
        $('#redirectmodal').css({
            "display": "none",
            "opacity": "0"
        });
        $('body').css({
            "overflow": "visible"
        });
    });

    $('.redirectmodal-container *').click(function (e) {
        e.stopPropagation();
    });
});
function openRedirectModal(headline, link, loanId) {
 
    if (Cookies.get("emailtrackingid") === undefined) {
        blurScreen(5);

        $('#redirectmodal').animate({ opacity: 1 }, 300);

        $('#redirbtn').val("Videre til " + headline);
        $('#redirLoanId').val(loanId);
        $('#redirLink').val(link);
        $('#continuenoemail').attr("href", link);

        $('.redirectmodal-container').css("display", "block");
        $('#redirectmodal').css("display", "block");
        $('body').css({
            "overflow": "hidden"
        });
    } else {
        window.open(link, "_blank");
    }
} function noEmailRedirect(link) {
    window.open(link, "_blank");
}

function blurScreen(blurValue) {
    var blur = "blur(" + blurValue + "px)";

    if (blurValue == 0) {
        blur = "";
    }


    $('body > .frontpage-background').css({
        "-webkit-filter": blur,
        "filter": blur
    });
    $('body > .container').css({
        "-webkit-filter": blur,
        "filter": blur
    });
    $('body > .container-fluid').css({
        "-webkit-filter": blur,
        "filter": blur
    });
}